<template>
    <transition
        enter-class="opacity-0"
        enter-active-class="transition-opacity duration-200"
        leave-to-class="opacity-0"
        leave-active-class="transition-opacity duration-200"
    >
        <Layout v-show="ready" :show-background="true" container-class="max-w-sm px-4 py-10">
            <div v-if="ready">
                <div class="flex justify-center mb-8">
                    <img :src="config.service_logo" :alt="config.service_name" class="block w-auto h-12">
                </div>
                <h1 class="mb-4 text-xl font-bold leading-tight text-center text-highlight-100">
                    {{ _('device_flow_success_title') }}
                </h1>
                <p class="mb-24 text-sm text-center text-highlight-60">
                    {{ _('device_flow_step_2') }}
                </p>
                <div class="mb-18">
                    <h2 class="mb-8 text-lg font-bold leading-tight text-center text-highlight-100"
                        v-html="_('device_flow_success_subtitle',  {service_name: config.service_name})">
                    </h2>
                    <p class="leading-tight text-center text-highlight-100">
                        {{ _('device_flow_success_description') }}
                    </p>
                </div>
            </div>
        </Layout>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import NProgress from 'nprogress'
import Layout from '@/components/Layout.vue'

export default {
    components: {
        Layout,
    },
    computed: {
        ...mapGetters({
            fetched: 'localisation/fetched',
            _: 'localisation/translate',
            client: 'settings/getClient',
            user: 'user/get',
            authenticated: 'user/authenticated',
        }),
    },
    created() {
        NProgress.start()
    },
    async mounted() {
        if (Object.keys(this.authenticated).length) {
            const { access_token } = this.authenticated
            this.$store.dispatch('user/get', access_token)
        }

        this.config = await import(`@/resources/${this.client}`)
    },
    watch: {
        fetched: {
            immediate: true,
            deep: true,
            handler(fetched) {
                if (fetched) {
                    setTimeout(() => {
                        this.ready = true
                        NProgress.done()
                    }, 1000)
                }
            },
        },
    },
    data() {
        return {
            config: '',
            ready: false,
        }
    },
}
</script>
